query ComputedDeliverableComponents($campaignId: ID!) {
    computedDeliverableComponents(campaignId: $campaignId) {
        deliverableCount
        editableGroupValues {
            _id
            editableGroupName
            value
        }
        languages {
            label
            value
        }
        masterTemplates {
            _id
            height
            width
        }
    }
}
